import Playground from 'components/Playground';
import Tab from "components/Tab";
import Nav from "components/Nav";
import * as React from 'react';
export default {
  Playground,
  Tab,
  Nav,
  React
};